import { AdvancingParticipantsPanel } from "advancing/components/AdvancingParticipantsPanel";
import { getProvideSidePanelQuery } from "advancingprovide/utils";
import React from "react";
import { useParams } from "react-router";
import { useCustomQuery } from "utilities/hookutils";

export const ParticipantsTab = () => {
  const { secret } = useParams();
  const sidePanelQuery = useCustomQuery(getProvideSidePanelQuery(secret));

  return <AdvancingParticipantsPanel
    participants={sidePanelQuery.data?.data.participants ?? []}
    isLoading={sidePanelQuery.isLoading}
  />;
};
